// extracted by mini-css-extract-plugin
module.exports = {"whiteInput":"FeesDetailsSection_whiteInput__15CcJ","howFessWillBePaidSection":"FeesDetailsSection_howFessWillBePaidSection__3VlIv","details":"FeesDetailsSection_details__yGls_"};